import type { FixHubPermissions } from "resources/permissions";
import { usePermissionChecker } from "./usePermissionChecker";

export function usePermission(policyKey: FixHubPermissions) {
  const { hasSomePermissions } = usePermissionChecker();
  return hasSomePermissions([policyKey]);
}
